import { Send, Sync } from "@mui/icons-material";
import { Box, Stack, Typography } from "@mui/material";
import { SectionHeader } from "@shared/components";
import StatisticsCard from "../components/StatisticsCard";
import WelcomeCard from "../components/WelcomeCard";
import { useGetOverviewDashboard } from "../services/useGetOverviewDashboard";
import Loader from "@mantis-theme/components/Loader";
import { StatsConfig } from "../utils/types";
import { useEffect, useMemo } from "react";

const Dashboard = () => {
  const { data, isLoading, isError } = useGetOverviewDashboard();

  useEffect(() => {
    if (data) {
      localStorage.setItem("dashboard-overview", JSON.stringify(data));
    }
  }, [data]);

  const statsConfig = useMemo<StatsConfig[]>(() => {
    if (!data) return [];

    return [
      {
        title: "Number of pushes",
        value: data.totalPushes ?? 0,
        subtitle: `Last push: ${data.lastPushAt ? new Date(data.lastPushAt).toLocaleDateString() : "N/A"}`,
        icon: <Send />,
        color: "primary",
      },
      {
        title: "Updates after last push",
        value: data.totalUpdateCount ?? 0,
        subtitle: `Since last push: ${data.totalUpdateCount ?? 0} changes made by users`,
        icon: <Sync />,
        color: "warning",
      },
    ];
  }, [data]);

  if (isLoading) return <Loader />;

  if (isError || !data) {
    return (
      <Box p={3}>
        <SectionHeader title="Dashboard" />
        <Typography color="error" sx={{ mt: 2 }}>
          Failed to load dashboard data. Please try again later.
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      <SectionHeader title="Dashboard" />
      <WelcomeCard />

      <Box sx={{ mt: 6, mb: 4 }}>
        <SectionHeader title="Statistics Overview" />

        <Stack spacing={3} direction={{ xs: "column", md: "row" }} sx={{ mt: 4 }}>
          {statsConfig.map((stat, index) => (
            <Box key={index} sx={{ flex: 1, minWidth: 0, maxWidth: 380 }}>
              <StatisticsCard title={stat.title} value={stat.value.toLocaleString()} subtitle={stat.subtitle} icon={stat.icon} color={stat.color} />
            </Box>
          ))}
        </Stack>
      </Box>
    </Box>
  );
};

export default Dashboard;
